import { Alert } from './icons';
import { ArrowDown } from './icons';
import { ArrowLeft } from './icons';
import { ArrowRight } from './icons';
import { ArrowUp } from './icons';
import { Balcony } from './icons';
import { Bath } from './icons';
import { Bbq } from './icons';
import { Beach2 } from './icons';
import { Bell } from './icons';
import { BellRinging } from './icons';
import { Boat } from './icons';
import { Bread } from './icons';
import { Buildings } from './icons';
import { BuildingStore } from './icons';
import { Calendar } from './icons';
import { CalendarDown } from './icons';
import { CalendarMinus } from './icons';
import { CalendarUp } from './icons';
import { CalendarPlus } from './icons';
import { ChannelAirbnb } from './icons';
import { ChannelBookingcom } from './icons';
import { ChatToUs } from './icons';
import { Checkmark } from './icons';
import { ChevronDown } from './icons';
import { ChevronLeft } from './icons';
import { ChevronRight } from './icons';
import { ChevronUp } from './icons';
import { Close } from './icons';
import { CoffeeMachine } from './icons';
import { Copy } from './icons';
import { Cot } from './icons';
import { Detector } from './icons';
import { Disability } from './icons';
import { Dishwasher } from './icons';
import { Door } from './icons';
import { DotsHorizontal } from './icons';
import { DotsVertical } from './icons';
import { DoubleBed } from './icons';
import { DoubleChatBubble } from './icons';
import { Download } from './icons';
import { Eye } from './icons';
import { File } from './icons';
import { FilePlus } from './icons';
import { Fire } from './icons';
import { Flowers } from './icons';
import { Gauge } from './icons';
import { Hairdryer } from './icons';
import { Highchair } from './icons';
import { Home } from './icons';
import { HotTub } from './icons';
import { House } from './icons';
import { Ice } from './icons';
import { Information } from './icons';
import { Iron } from './icons';
import { Kettle2 } from './icons';
import { Link } from './icons';
import { Lock } from './icons';
import { LockUnlocked } from './icons';
import { MiniFridge } from './icons';
import { Minus } from './icons';
import { Monitor } from './icons';
import { Mountain } from './icons';
import { Oven } from './icons';
import { Parasol } from './icons';
import { Parking } from './icons';
import { Party } from './icons';
import { Password } from './icons';
import { Pencil } from './icons';
import { Photo } from './icons';
import { PicnicBench } from './icons';
import { PinOnMap } from './icons';
import { Plus } from './icons';
import { Pot } from './icons';
import { Radio } from './icons';
import { Refresh } from './icons';
import { Search } from './icons';
import { Settings } from './icons';
import { SettingsSliders } from './icons';
import { Share } from './icons';
import { SoapPump } from './icons';
import { Sunrise2 } from './icons';
import { SwimmingPool } from './icons';
import { Trash } from './icons';
import { Trees } from './icons';
import { TumbleDryer } from './icons';
import { Wallpaper } from './icons';
import { WarningTriangle } from './icons';
import { WashingMachine } from './icons';
import { Wifi } from './icons';
import nav from './icons/nav';
export const icons = Object.assign({ Alert,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    Balcony,
    Bath,
    Bbq,
    Beach2,
    Bell,
    BellRinging,
    Boat,
    Bread,
    Buildings,
    BuildingStore,
    Calendar,
    CalendarDown,
    CalendarMinus,
    CalendarUp,
    CalendarPlus,
    ChannelAirbnb,
    ChannelBookingcom,
    ChatToUs,
    Checkmark,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Close,
    CoffeeMachine,
    Copy,
    Cot,
    Detector,
    Disability,
    Dishwasher,
    Door,
    DotsHorizontal,
    DotsVertical,
    DoubleChatBubble,
    DoubleBed,
    Download,
    Eye,
    File,
    FilePlus,
    Fire,
    Flowers,
    Gauge,
    Hairdryer,
    Highchair,
    Home,
    HotTub,
    House,
    Information,
    Iron,
    Ice,
    Kettle2,
    Link,
    Lock,
    LockUnlocked,
    MiniFridge,
    Minus,
    Monitor,
    Mountain,
    Oven,
    Parasol,
    Parking,
    Party,
    Password,
    Pencil,
    Photo,
    PicnicBench,
    PinOnMap,
    Plus,
    Pot,
    Radio,
    Refresh,
    Search,
    Settings,
    SettingsSliders,
    Share,
    SoapPump,
    Sunrise2,
    SwimmingPool,
    Trees,
    Trash,
    TumbleDryer,
    Wallpaper,
    WarningTriangle,
    WashingMachine,
    Wifi }, nav);
//# sourceMappingURL=icon-lookup.js.map